import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'dark';
  });

  useEffect(() => {
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  const colors = {
    light: {
      // Белая и желтая тема
      bg: 'bg-white',
      bgSecondary: 'bg-yellow-50',
      bgCard: 'bg-white',
      bgInput: 'bg-white',
      bgButton: 'bg-yellow-400',
      bgButtonHover: 'hover:bg-yellow-500',
      bgPrimary: 'bg-yellow-400',
      bgPrimaryHover: 'hover:bg-yellow-500',
      bgAccent: 'bg-purple-600',
      bgAccentHover: 'hover:bg-purple-700',
      text: 'text-gray-900',
      textSecondary: 'text-gray-600',
      textMuted: 'text-gray-500',
      textPrimary: 'text-purple-600',
      border: 'border-gray-300',
      borderFocus: 'focus:border-purple-500',
      borderCard: 'border-gray-200',
    },
    dark: {
      // Серая и фиолетовая тема
      bg: 'bg-gray-900',
      bgSecondary: 'bg-gray-800',
      bgCard: 'bg-gray-800',
      bgInput: 'bg-gray-700',
      bgButton: 'bg-purple-600',
      bgButtonHover: 'hover:bg-purple-700',
      bgPrimary: 'bg-purple-600',
      bgPrimaryHover: 'hover:bg-purple-700',
      bgAccent: 'bg-purple-500',
      bgAccentHover: 'hover:bg-purple-600',
      text: 'text-gray-200',
      textSecondary: 'text-gray-400',
      textMuted: 'text-gray-500',
      textPrimary: 'text-purple-400',
      border: 'border-gray-700',
      borderFocus: 'focus:border-purple-500',
      borderCard: 'border-gray-700',
    }
  };

  const value = {
    theme,
    setTheme,
    toggleTheme,
    isDark: theme === 'dark',
    colors: colors[theme],
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
